import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Select from "../select/Select";
import ValidationMessages from "../form/ValidationMessages";
import { userGroupById } from "../../config/selectors";

class InputSelectUserGroup extends React.Component {
	render() {
		const { userGroups } = this.props;
		const options = Object.keys(userGroups).map(levelId => {
			return { value: Number(levelId), label: userGroups[levelId].Description };
		});

		return (
			<div>
				<Select
					options={options}
					disabled={this.props.disabled}
					name={this.props.name}
					onChange={this.props.onChange}
					value={this.props.value}
				/>

				<ValidationMessages messages={this.props.validationMessages} />
			</div>
		);
	}
}

InputSelectUserGroup.defaultProps = {
	validaitonClassName: "form-validation-box",
	disabled: false
};

InputSelectUserGroup.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.number,
	onChange: PropTypes.func.isRequired,
	validaitonClassName: PropTypes.string,
	validationMessages: PropTypes.arrayOf(PropTypes.string),
	disabled: PropTypes.bool
};

const mapStateToProps = state => {
	return {
		userGroups: userGroupById(state)
	};
};

export default connect(mapStateToProps)(InputSelectUserGroup);
